export default __webpack_public_path__ + "static/media/ACUTE-GOUT.43c91737.png";